import { render } from "./Result3D.vue?vue&type=template&id=df822e7e"
import script from "./Result3D.vue?vue&type=script&lang=js"
export * from "./Result3D.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__